import React, { useState } from "react";
import {
	Box,
	Typography,
	Paper,
	TextField,
	InputAdornment,
	Tabs,
	Tab,
} from "@mui/material";
import AppLayout from "../../components/AppLayout";
import SearchIcon from "@mui/icons-material/Search";
import EstoqueSaidas from "./EstoqueSaidas";
import EstoqueEntradas from "./EstoqueEntradas";

function Estoque() {
	const [activeTab, setActiveTab] = useState(0);
	const [searchTerm, setSearchTerm] = useState("");

	const unidadeDistribuidoraId = localStorage.getItem("selected_unidade_id");

	// As abas listam coisas diferentes (produto acabado, que e o produto final das
	// ordens de producao, x materia-prima, que e o lote de entrada ainda nao
	// processado), entao carregar a busca de uma na outra so traria resultado vazio.
	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
		setSearchTerm("");
	};

	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
	};

	return (
		<AppLayout currentPage="estoque">
			<Box sx={{ maxWidth: 1400, mx: "auto" }}>
				{/* Header com busca */}
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						mb: 3,
					}}
				>
					<Typography
						variant="h4"
						sx={{
							color: "#666",
							fontWeight: 600,
						}}
					>
						Estoque
					</Typography>
					<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
						<TextField
							size="small"
							placeholder="Buscar..."
							value={searchTerm}
							onChange={handleSearchChange}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
							sx={{
								width: "300px",
								"& .MuiOutlinedInput-root": {
									borderRadius: "8px",
								},
							}}
						/>
					</Box>
				</Box>

				<Paper
					sx={{
						bgcolor: "white",
						borderRadius: "12px",
						boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
						overflow: "hidden",
					}}
				>
					<Tabs
						value={activeTab}
						onChange={handleTabChange}
						sx={{
							borderBottom: 1,
							borderColor: "divider",
							px: 2,
						}}
					>
						<Tab label="Produto Acabado" />
						<Tab label="Matéria-Prima" />
					</Tabs>

					{activeTab === 0 ? (
						<EstoqueSaidas
							unidadeDistribuidoraId={unidadeDistribuidoraId}
							searchTerm={searchTerm}
						/>
					) : (
						<EstoqueEntradas
							unidadeDistribuidoraId={unidadeDistribuidoraId}
							searchTerm={searchTerm}
						/>
					)}
				</Paper>
			</Box>
		</AppLayout>
	);
}

export default Estoque;
